export default __webpack_public_path__ + "static/media/microsoft-azure-horizontal.59b82301.svg";